import CONFIG from './config';
import findIndex from 'lodash/findIndex'
export const processDoLoopInfo = ({addressID, phoneNumber, state, city, street, zipCode}) =>{
    return  {
        "zipCode":`${zipCode}`,
        "city":city,
        "state":state,
        "unit":"",
        "streetAddress":'',
        "streetTerm":'',
        "unitTerm":"",
        "AddressID":addressID,
        "rawaddr":"",
        "BaseAddressID": addressID,
        "Retry":"Y",
        "RememberMe":"",
        "IsNonDO":"N",
        "TelephNoLQ":"",
        "EmailLQ":"",
        "InternalTest":"",
        "GUID": Math.random().toString()?.replace('.', ''),
        "FromAmazonURL":"",
        "OneFiberOverlay":"N",
        "AmexOverlay":"",
        "FromAmexMLP":"N",
        "CloverMLP":"N",
        "page_URL": `${CONFIG.domain}/foryoursmallbiz/fiosorder`,
        "JourneyEntryURL": `${CONFIG.domain}/foryoursmallbiz/fiosorder`,
        "campaign_Id":"Messsage=UNKNOWN",
        "EntryPoint":"",
        "VeteranDiscount":"N",
        "SkipPendingOrderFlag":"Y",
        "VZWTN": phoneNumber ? `${phoneNumber}`?.replace(/-/g, "") : "",
        "ABLogicValue":"N"
    };

}

export const getTableData = (excelData) => {
    let headers = [];
    let contents = [];
    if(excelData && excelData[0]) {
        contents = excelData.splice(1);
        headers = excelData;
    }
    return { headers , contents} ;
}

function fetchDataForField(row, header, field) {
    const index = header?.indexOf(field);
    return index > -1  ? row[index] : '';
}

export const processDataRow = (row, header) => { 
    const addressID = fetchDataForField(row, header, 'strAddressId') 
    const phoneNumber = fetchDataForField(row, header, 'strBTN')  
    const state = fetchDataForField(row, header, 'strState');
    const email = fetchDataForField(row, header, 'strEmail');  
    const city = fetchDataForField(row, header, 'strCity');  
    const street = fetchDataForField(row, header, 'strServiceAddress');  
    const zipCode = fetchDataForField(row, header, 'strServzipCode');  


    return {
        addressID, phoneNumber, state, email, city, street, zipCode
    }
}

function constructFormParams(params) {

    const formParams = new URLSearchParams();

    Object.keys(params).forEach(key => {
        formParams.append(key, params[key]);
    });

    return formParams;
}
